/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesIllustration,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';
import { propTypesPage } from '../Page/Page.proptypes';

export const propTypesContact = {
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    breadcrumb: PropTypes.arrayOf(
      PropTypes.shape({
        parent_name: PropTypes.string,
        parent_document: PropTypes.shape(propTypesPage),
      })
    ),
    breadcrumb_title: PropTypes.string,
    contact_description: PropTypes.string,
    contact_title: PropTypes.string,
    contact_topics: PropTypes.arrayOf(
      PropTypes.shape({
        color_icon: PropTypes.string,
        icon: PropTypes.string,
        topic: PropTypes.string,
      })
    ),
    form_id: PropTypes.string,
    form_type: PropTypes.string,
    logo_image: PropTypes.arrayOf(
      PropTypes.shape({ logo: PropTypes.shape(propTypesIllustration) })
    ),
    logo_title: PropTypes.string,
    main_cta_datatrack: PropTypes.string,
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    sector: PropTypes.string,
    title: PropTypes.shape(propTypesTextHtml),
  }),
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  uid: PropTypes.string,
};
